import Vue from 'vue';
import axios from 'axios';
import router from '../router';
import EventBus from './EventBus';

Vue.use(EventBus);
const vue = new Vue({});

const API_URL = process.env.NODE_ENV === 'production'
  ? 'https://time-sheet.meta.com.br/api'
  // : 'http://10.20.18.78:8093/api';
  : 'https://time-sheet.meta.com.br/api';

// Add base URL to axios api communication
axios.interceptors.request.use(config => {
  config.url = API_URL + config.url;

  if (vue.$localStorage.get('user')) {
    const user = JSON.parse(vue.$localStorage.get('user'));
    config.headers.common['Authorization'] = `Bearer ${user.access_token}`;
  }

  return config;
});

axios.interceptors.response.use(config => {
  if (!config.data.success && config.data.message === 'TOKEN_INVALID') {
    vue.$localStorage.set('user', '');
    return router.push({ name: 'Login' });
  }

  if (!config.data.success && config.data.message === 'TOKEN_EXPIRED') {
    vue.$events.$emit('refresh-token');
  }

  return config;
});


export default (V) => {
  Object.defineProperties(V.prototype, {
    $http: {
      get() {
        return axios;
      },
      post() {
        return axios;
      },
    },
  });
};
